import { cn } from "@/lib/cn";
import type { LucideIcon } from "lucide-react";
import { type ButtonHTMLAttributes, type CSSProperties, forwardRef } from "react";

export interface IconBtnProps extends Omit<ButtonHTMLAttributes<HTMLButtonElement>, "children"> {
  /** Lucide icon component */
  icon: LucideIcon;
  /** Accessible label for screen readers */
  label: string;
  /** Button diameter in px */
  size?: number;
  /** Optional notification badge count/text */
  badge?: string | number | null | undefined;
  className?: string;
  style?: CSSProperties;
}

/**
 * Circular ghost icon button using the iris-iconbtn CSS class.
 * Supports an optional notification badge overlay.
 */
export const IconBtn = forwardRef<HTMLButtonElement, IconBtnProps>(
  ({ icon: Icon, label, size = 36, badge, className, style, ...props }, ref) => {
    return (
      <button
        ref={ref}
        type="button"
        className={cn("iris-iconbtn", className)}
        aria-label={label}
        style={{ width: size, height: size, ...style }}
        {...props}
      >
        <Icon size={size * 0.45} strokeWidth={1.75} style={{ color: "var(--iris-fg-2)" }} />
        {badge != null && <span className="iris-iconbtn__badge">{badge}</span>}
      </button>
    );
  },
);
IconBtn.displayName = "IconBtn";
